import styled from "styled-components";
import { Paper, List as ListMaterialUI } from "@material-ui/core";

export const Container = styled(Paper)`
  max-width: 22.7rem;
  height: calc(100vh - 140px);
  display: flex;
  flex-direction: column;
`;

export const List = styled(ListMaterialUI)`
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
  background: #fefefe;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 0px 0px 0px 10px;

  padding: 0px;
  margin: 0px;
`;
